import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBicycle, faPencilAlt } from "@fortawesome/free-solid-svg-icons";

// eslint-disable-next-line react/display-name
const ScooterSingleTrip = React.memo(({
                                        isSelected,
                                        trip,
                                        onClick,
                                        onLoadQR,
                                        onEdit,
                                        scooterQR,
                                      }) => {
  const rideTime = (start, end) => Math.floor((end - start) / (60 * 1000));

  const paymentStatus = (type) => {
    switch (type) {
      case 0:
        return "Waiting";
      case 1:
        return "Paid";
      case 2:
        return "Rejected";
      case 3:
        return "Debt (multiple rejected)";
      case 4:
        return "Refunded";
      default:
    }
  };

  const handleEdit = ev => {
    ev.preventDefault();
    onEdit();
  };

  const totalPause = Math.round((trip && Array.isArray(trip.pauses) ? trip.pauses.reduce((total, current) => {
    total += current.end - current.start;
    return total;
  }, 0) : 0) / 60000);
  const totalPausePrice = (trip && trip.billingModeTariff ? trip.billingModeTariff.pausePrice : 0) * totalPause;

  return (
    <div className={`position-relative trip g-pointer ${isSelected ? "active" : ""}`} onClick={() => onClick(trip.id)}>
      <div style={{
        position: "absolute",
        right: 0,
        bottom: 28
      }}>
        <button onClick={handleEdit} title="Edit trip" className="btn btn-danger btn-sm">
          <FontAwesomeIcon icon={faPencilAlt}/>
        </button>
      </div>
      <div className="position-relative tripMinutes">
        <div className="">
          <div className="count">
            {rideTime(trip.start, trip.end)}
          </div>
          <div className="title">
            minutes
          </div>

          <div className="position-absolute w-100 text-center pausesPrice bg-info">{totalPausePrice ?
            <span className="mr-2">Pauses Price: ~{totalPausePrice}</span> : null}</div>
        </div>
      </div>
      <div className="tripDetails">
        <div className="tripDetailsBox">
          <div><i className="fas fa-circle"/> {trip.start && moment(trip.start)
            .format("HH:mm YYYY-MM-DD")} </div>
          <div className="details">
            <div>{(trip.endMileage - trip.startMileage).toFixed(2) / 1000} km</div>
          </div>
          <div><i className="fas fa-circle"/> {trip.end && moment(trip.end)
            .format("HH:mm YYYY-MM-DD")} </div>
        </div>
        {trip.payment &&
          <div className="payment">
            <div className="price">
              {trip.payment.amount}
            </div>
            <div className="type">
              AMD
            </div>
            <div className="status">
              {paymentStatus(trip.payment && trip.payment.status)}
            </div>
          </div>}
      </div>
      <div className="d-flex justify-content-center align-trips-center position-absolute bg-success trip-bike">
        {scooterQR || (
          <button
            className="btn btn-sm btn-warning btn-block"
            onClick={() => onLoadQR(trip.scooter)}
          >
            <FontAwesomeIcon icon={faBicycle} title="Scooter"/> Get Scooter QR
          </button>
        )}
      </div>
    </div>
  );
});

export default ScooterSingleTrip;



// WEBPACK FOOTER //
// ./src/views/pages/users/components/scooter-single-trip.js